module.exports = {
	'customFolder.m3.m310320': {
		'userSettings': '工作时间设置',
		'scheduleGroupName': '群組',
		'unpin': '取消釘選',
		'nailDown': '釘選',
	},
	'customFolder.m3.m310320_grid': {
		'shiftType': '班别类型',
		'thereAreClassesLeft': '还有<%=temp1%>个班别',
		'shiftInformationLabel': '班别 / 标签',
		'joinTheWorkforce': '加入人力',
		'editStaff': '编辑人力',
		'duplicateWorkingHoursTimePeriod': '工作时间重迭',
		'time': '時',
		'breakTime': '休息时间',
	},
};
